/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function OrderEdit(props) {
  const { login, onClosePop, seq } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState();
  const [tmcd, setTmcd] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [pass1, setPass1] = useState("");
  const [pass2, setPass2] = useState("");
  const [birth, setBirth] = useState("");
  const [sex, setSex] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [address, setAddress] = useState("");

  // 데이타폼
  const [data, setData] = useState({
    token: token,
    cid: login.cid,
    level: login.level,
    mcd: login.mcd,
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const onSubmit = async () => {

    pr('seq=' + seq);
    pr('tcid=' + data.tcid);
    pr('name=' + name);
    pr('pass1=' + pass1);
    pr('pass2=' + pass2);
    pr('birth=' + birth);
    pr('sex=' + sex);
    pr('weight=' + weight);
    pr('height=' + height);

    let result = await axios.post(
      configState.api + "/gympass_admin/member_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
        tcid: tcid,
        name: name,
        pass1: pass1,
        pass2: pass2,
        birth: birth,
        sex: sex,
        weight: weight,
        height: height,
        phone: phone,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/member_one",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq,
      }
    );
    if (result.data.success === 1) {
      setName(result.data.row.name);
      setPhone(result.data.row.phone);
      setBirth(result.data.row.birth);
      setSex(result.data.row.sex);
      setWeight(result.data.row.weight);
      setHeight(result.data.row.height);
      setData((state) => {
        return { ...state, tcid: result.data.row.tcid };
      });
      setTmcd(result.data.row.mcd);
      setTcid(result.data.row.tcid);
      setAddress(result.data.row.address);

    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onDeleteClick = () => {
    Swal.fire({
      title: "삭제하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass_admin/member_del",
            {
              token: token,
              cid: login.cid,
              level: login.level,
              mcd: login.mcd,
              seq: seq,
            }
          );
          if (result.data.success === 1) {
            onClosePop();
          } else {
            Swal.fire(result.data.msg);
          }
        }
      })
      .catch((e) => alert(e));
  };

  useEffect(() => {
    load_data();
  }, [seq]);

  return (
    <Box>
      <Box
        css={css`
          padding: 20px 60px;
        `}
      >

        {/* 센터명 */}
        <CenterSelect
          login={login}
          tcidParent={tcid}
          setTcidParent={setTcid}
        />

        {/* 고객명 */}
        <Box
          display="flex"
          alignItems="center"
          sx={{ pt: 1 }}
        >
          <TextField
            name="name"
            label="고객명"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></TextField>
          <Box sx={{ pl: 1 }}>{tmcd}</Box>
        </Box>

        {/* 연락처 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
          display="flex"
          alignItems="center"
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="phone"
            label="연락처"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={phone}
          ></TextField>
          <Box sx={{ ml: 1 }}>(변경불가)</Box>
        </Box>

        {/* 비밀번호 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            type="password"
            name="pass1"
            label="비밀번호"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={pass1}
            onChange={(e) => setPass1(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}>(변경시 입력) 4~12자리 영문과 숫자로 입력</Box>
        </Box>

        {/* 비밀번호 확인 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            type="password"
            name="pass2"
            label="비밀번호 확인"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={pass2}
            onChange={(e) => setPass2(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}></Box>
        </Box>

        {/* 생일 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="birth"
            label="생일"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={birth}
            onChange={(e) => setBirth(e.target.value)}
          ></TextField>
          <Box sx={{ ml: 1 }}>0000-00-00 형식으로 입력</Box>
        </Box>

        {/* 주소 */}
        <Box
          display="flex"
          alignItems="center"
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="address"
            label="주소"
            size="small"           
            autoComplete="off"
            fullWidth
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          ></TextField>          
        </Box>

        {/* 성별 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <FormLabel>성별</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            name="sex"
            onChange={(e) => setSex(e.target.value)}
            value={sex}
          >
            <FormControlLabel value="남" control={<Radio />} label="남" />
            <FormControlLabel value="여" control={<Radio />} label="여" />
          </RadioGroup>
        </FormControl>

        {/* 키 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="height"
            label="키"
            size="small"
            sx={{
              width: "180px",
            }}
            autoComplete="off"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
          ></TextField>
          <TextField
            name="weight"
            label="몸무게"
            size="small"
            sx={{
              ml: 1,
              width: "180px",
            }}
            autoComplete="off"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
          ></TextField>
        </Box>




        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>

          <Button
            variant="contained"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onDeleteClick}
          >
            삭제
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default OrderEdit;
